/**
 * PostgREST / supabase-js errors when a relation is absent from the API schema
 * (migration not applied on the linked project, or stale schema cache).
 */
export function isPostgrestRelationMissing(err: unknown): boolean {
  if (typeof err !== 'object' || err === null) return false;
  return (err as { code?: string }).code === 'PGRST205';
}

/**
 * PostgreSQL `42P01` — relation/table not found at runtime.
 * Triggered when a DB function/trigger references a table that hasn't been created yet
 * (e.g. `ggj_b2b_outbox_events` in migrations 047/055 that may not be deployed).
 */
export function isUndefinedTableError(err: unknown): boolean {
  if (typeof err !== 'object' || err === null) return false;
  const code = (err as { code?: string }).code;
  // 42P01 = PostgreSQL undefined_table; PGRST205 = PostgREST schema-cache miss
  return code === '42P01' || code === 'PGRST205';
}
